/*global firebase */

import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { StateProvider } from "./appContext";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  firebase.functions().useFunctionsEmulator("http://localhost:4001");
}

ReactDOM.render(
  <React.StrictMode>
    <StateProvider>
      <App />
    </StateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
